import { createSelector } from '@reduxjs/toolkit';

const cartItemsSelector = (state) => state.cartProduct;
const cartComboServiceSelector = (state) => state.cartComboService;

// Count number of products in cart
const cartProductCountSelector = createSelector(cartItemsSelector, (cartItems) => {
    return cartItems.cartProductInfo.length || 0;
});
const cartComboServiceCountSelector = createSelector(cartComboServiceSelector, (cartItems) => {
    return cartItems.cartComboServiceInfo.length || 0;
});
export const cartItemsCountSelector = createSelector(
    cartProductCountSelector,
    cartComboServiceCountSelector,
    (cartProductCountSelector, cartComboServiceCountSelector) => {
        return cartProductCountSelector + cartComboServiceCountSelector || 0;
    },
);
